<button class="explore-plus-btn" (click)="this.handleUpgradePopupOpen()" [disabled]="isUpgradePopupOpened$ | async">
  <span [translate]="'navigation.explore-plus.button.title'"></span>
</button>
